<template>
  <div :class="['v-flow-step', {'v-flow-step--done': done, 'v-flow-step--active': active }]">
    <div class="d-flex v-flow-step__center">
      <div class="v-flow-step__icon">
        <v-icon v-if="done" name="checkmark" width="11" />
        <v-text v-else font-size="2" bold>{{number}}</v-text>
      </div>
      <div
        @click="toggleContent()"
        :class="[
          'v-flow-step__title',
          hasContent && 'v-flow-step__title--clickable',
          showContent && 'v-flow-step__title--expanded'
        ]">
        <v-text
          :bold="active"
          :class="[active && 'text-primary', done && 'text-dark']"
        >{{title}}</v-text>
        <v-icon v-if="hasContent" class="text-gray-dark" name="caret-thick" width="7"/>
      </div>
    </div>
    <div v-if="showContent" class="v-flow-step__content">
      <v-text size="small" class="text-placeholder">
        <slot />
      </v-text>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    done: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      number: null,
      showContent: false
    };
  },
  computed: {
    hasContent() {
      return !!this.$slots.default;
    }
  },
  mounted() {
    this.number = [...this.$el.parentNode.children].indexOf(this.$el) + 1;
  },
  methods: {
    toggleContent() {
      if (!this.hasContent) return;
      this.showContent = !this.showContent;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-flow-step {
  padding: $spacer 0;
  position: relative;

  @media screen and (max-width: 768px) {
    width: 100%;
    justify-content: center;
    z-index: 2;

    &__center {
      justify-content: center;
    }
  }

  @media screen and (max-width: 768px) {
    &:before {
      position: absolute;
      content: "";
      border-top: 2px solid #cccccc50;
      width: 100%;
      top: 28px;
      left: 55%;
      height: 100%;
      z-index: 1;
    }

    &:last-child::before {
      content: none;
    }
  }

  &--done {
    @media screen and (min-width: 769px) {
      &:before {
        position: absolute;
        content: "";
        border-left: 2px solid theme-color("primary");
        width: 100%;
        top: 36px;
        left: 11px;
        height: 100%;
      }
    }

    @media screen and (max-width: 768px) {
      &:before {
        position: absolute;
        content: "";
        border-top: 2px solid theme-color("primary");
        width: 100%;
        top: 28px;
        left: 55%;
        height: 100%;
        z-index: 1;
      }
    }
    &:last-child::before {
      content: none;
    }
  }

  &__icon {
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: theme-color("white");
    color: theme-color("placeholder");

    .v-flow-step--done &,
    .v-flow-step--active & {
      color: theme-color("white");
      background-color: theme-color("primary");
    }
  }

  &__title {
    margin-left: $spacer;
    display: flex;
    align-items: center;
    flex-grow: 1;

    @media screen and (max-width: 768px) {
      display: none;
    }

    &--clickable {
      cursor: pointer;
    }

    &--expanded {
      >>> .v-icon {
        transform: rotate(180deg);
      }
    }

    >>> .v-text {
      color: theme-color("placeholder");
      flex-grow: 1;
    }
  }

  &__content {
    padding-top: 12px;
    padding-left: 50px;

    >>> .v-text {
      a {
        display: block;
        margin-top: $spacer * 0.25;
      }

      div + div {
        margin-top: $spacer * 0.25;
      }
    }
  }
}
</style>
